import React from 'react';
import styled from 'styled-components';
import texture from '../../../assets/newAssets/sliders/texture.png';
import BirdImage from '../../../assets/newAssets/sliders/calltoaction.webp';
import { OrangeBtn, LightGreenBtn } from '../../../newComponents/Button/ButtonSkin';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

const Container = styled.div`
    position: relative; /* <-- new: create stacking context */
    display: flex;
    width: 100%;
    min-height: 400px;
    background-color: #1a5c4a;
    overflow: hidden;

    @media (max-width: 768px) {
        flex-direction: column;
        min-height: 600px;
    }
`;

/* NEW: full-bleed texture overlay */
const TextureOverlay = styled.div`
    position: absolute;
    inset: 0;
    background: url(${texture}) repeat;
    background-size: cover; /* or try 800px auto if you prefer tighter grain */
    opacity: 0.5; /* match Figma */
    mix-blend-mode: multiply; /* match Figma */
    pointer-events: none;
    z-index: 1; /* below content, above background */
`;

const ImageSection = styled.div`
    flex: 0 0 40%;
    position: relative;
    z-index: 2; /* keep bird above the overlay */
    overflow: visible;
    clip-path: ellipse(100% 100% at 0% 50%);

    @media (max-width: 768px) {
        flex: 0 0 300px;
        clip-path: ellipse(100% 100% at 50% 0%);
    }
`;

const StyledBirdImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
`;

const ContentSection = styled.div`
    position: relative;
    z-index: 2; /* keep text/buttons above the overlay */
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 60px 40px;
    gap: 40px;
    margin: auto 0;

    @media (max-width: 768px) {
        padding: 40px 20px;
    }
`;

const Title = styled.div`
    color: var(--Regenera-Clarity-White, #fff);
    text-align: center;
    font-family: Montserrat;
    font-size: 48px;
    font-weight: 500;
    line-height: 58px;
    max-width: 570px;

    @media (max-width: 768px) {
        font-size: 36px;
        margin-bottom: 30px;
    }
`;

const ButtonGroup = styled.div`
    display: flex;
    gap: 20px;
    align-items: center;

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 15px;
        width: 100%;
    }
`;

const PartnerWithNature = ({ user }) => {
    return (
        <Container>
            <TextureOverlay />
            <ImageSection>
                <StyledBirdImage
                    src={BirdImage || '/placeholder.svg'}
                    alt="Beautiful bird in nature"
                />
            </ImageSection>

            <ContentSection>
                <Title>
                    <FormattedMessage
                        id="LandingPage.ImageText.title"
                        defaultMessage="Partner with Nature today!"
                    />
                </Title>
                <ButtonGroup>
                    <OrangeBtn className="sign-up-btn">
                        {user ? (
                            <Link to="/subscription/signup">
                                <FormattedMessage
                                    id="LandingPage.CallToAction.joinNow"
                                    defaultMessage="Join Now"
                                />
                            </Link>
                        ) : (
                            <Link to="/signup/start">
                                <FormattedMessage
                                    id="LandingPage.CallToAction.signUp"
                                    defaultMessage="Sign up"
                                />
                            </Link>
                        )}
                    </OrangeBtn>
                    <LightGreenBtn>
                        <Link to="/organisation/calculator">
                            <FormattedMessage
                                id="Blogs.Contribute.calculate"
                                defaultMessage="Calculate your footprint"
                            />
                        </Link>
                    </LightGreenBtn>
                </ButtonGroup>
            </ContentSection>
        </Container>
    );
};

export default PartnerWithNature;
